import {
  prefix
} from './src/utils/constant'
import {
  mapObject
} from './src/utils'
import './common'

import print from './src/components/others/print'
import dropDown from './src/components/others/drop-down/drop-down'
import dropDownItem from './src/components/others/drop-down/drop-down-item'
import sideDrawer from './src/components/others/side-drawer'
import tooltip from './src/components/others/tooltip'
import tooltipConfirm from './src/components/others/tooltip-confirm'
import dragBox from './src/components/others/drag-box'

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

NProgress.configure({
  ease: 'ease',
  speed: 200,
  showSpinner: false
})

let components = {
  print,
  dropDown,
  dropDownItem,
  sideDrawer,
  tooltip,
  tooltipConfirm,
  dragBox
}

const install = Vue => {
  mapObject(components, component => {
    if (component.name) {
      Vue.component(prefix + component.name, component)
    } else {
      console.error('组件注册失败：缺少name')
    }
  })

  Vue.prototype.$pagoda.loading = NProgress
  // 向下兼容
  Vue.prototype.$pagodaLoading = NProgress
}

export default {
  install
}
